<template>
  <section class="blog-quote-images">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="sectionStyles">
      <div class="container">
        <img
          :src="shopifyData.image"
          :alt="shopifyData.image.alt"
          class="quote-image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Quote Image"
          width=""
          height=""
        />
      </div>
    </a>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionStyles() {
      return {
        paddingTop:
          window.innerWidth > 768
            ? this.shopifyData.deskPaddingTop + 'px'
            : this.shopifyData.mobPaddingTop + 'px',
        paddingBottom:
          window.innerWidth > 768
            ? this.shopifyData.deskPaddingBottom + 'px'
            : this.shopifyData.mobPaddingBottom + 'px',
      };
    },
    altText() {
      return 'Quote Image';
    },
  },
};
</script>

<style scoped>
/* .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  } */

.blog-quote-images {
  text-align: center;
}
.blog-quote-images a {
  display: block;
}

.quote-image {
  display: block;
  /* max-width: 544px; */
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
}
</style>
